export enum PublicEventType {
  AddToCart = 'pimster.add_to_cart',
  AddToCartResponse = 'pimster.add_to_cart_response',
}
